import React, { useEffect, useState } from "react";
import "./index.css";
import { getEventById, postPurchaseTickets } from "../../api/events";
import { useParams } from "react-router";
import { Spinner } from "react-bootstrap";
import TicketSummaryModal from "../../components/ticketSummaryModal";
import { Helmet } from "react-helmet";

export default function EventsPage() {
  const { id: eventId } = useParams();
  let { metaTitle, metaDescription, metaImage } = "";
  if (Number(eventId) === 1) {
    metaTitle = "Piano Concert by Dr. Antoine Karam";
    metaDescription = "Abu Dhabi International School";
    metaImage =
      "https://schoolpay.blob.core.windows.net/public/events-images/AD-Event-1-1.png";
  } else {
    metaTitle = "Purchase Ticket";
    metaDescription = "Powered by PAYNEST FINTECH LTD.";
    metaImage =
      "data:image/png;base64,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";
  }

  const queryParams = new URLSearchParams(window.location.search);
  const queryStatus = queryParams.get("status");
  const queryMessage = queryParams.get("message");
  const queryOrderId = queryParams.get("orderId");

  const [paymentStatus, setPaymentStatus] = useState(null);
  const [paymentMessage, setPaymentMessage] = useState(null);

  const [fetching, setFetching] = useState(true);
  const [eventData, setEventData] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const [inputFormData, setInputFormData] = useState({});
  const [quantities, setQuantities] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);

  const submitGatewayFormRef = React.useRef(null);
  const [gatewayFormData, setGatewayFormData] = useState(null);
  const [showTicketSummary, setShowTicketSummary] = useState(null);

  const handleInputChange = (e) => {
    console.log(e.target.id, e.target.value);
    setInputFormData({ ...inputFormData, [e.target.id]: e.target.value });
  };

  const handleQuantityChange = (ticketId, value) => {
    // Find the index of the ticket with the given ticketId
    const index = quantities.findIndex((q) => q.id === ticketId);

    // Create a new array and update the quantity of the corresponding ticket
    const newQuantities = [...quantities];
    newQuantities[index] = { ...newQuantities[index], quantity: value };
    setQuantities(newQuantities);
  };

  const handleQuantityDecrease = (e) => {
    e.preventDefault();
    const ticketId = Number(e.target.dataset.ticketId);
    const index = quantities.findIndex((q) => q.id === ticketId);

    const newQuantities = [...quantities];
    if (index >= 0 && newQuantities[index].quantity > 0) {
      newQuantities[index] = {
        ...newQuantities[index],
        quantity: newQuantities[index].quantity - 1,
      };
      setQuantities(newQuantities);
    }
  };

  const handleQuantityIncrease = (e) => {
    e.preventDefault();
    const ticketId = Number(e.target.dataset.ticketId);

    const index = quantities.findIndex((q) => q.id === ticketId);
    const newQuantities = [...quantities];

    if (index >= 0) {
      newQuantities[index] = {
        ...newQuantities[index],
        quantity: newQuantities[index].quantity + 1,
      };
      setQuantities(newQuantities);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (totalAmount === 0) {
      alert("Please select atleast one ticket");
      return;
    }

    console.log("form data", inputFormData);
    console.log("quantities", quantities);
    console.log("total amount", totalAmount);
    const data = {
      payeeInfo: JSON.stringify({
        ...inputFormData,
      }),
      ticketsQuantity: JSON.stringify([...quantities]),
    };
    console.log("data", data);

    postPurchaseTickets(eventId, data)
      .then((res) => {
        console.log(res);
        if (res.status === false) {
          alert(res.message);
          return;
        }
        setGatewayFormData(res.data);
        submitGatewayFormRef.current.submit();
      })
      .catch((err) => {
        console.log(err);
        alert(err.message);
      });
  };

  const handleModalClose = () => {
    setShowTicketSummary(false);
    setGatewayFormData(null);
    setInputFormData({});
    setQuantities(null);
    setTotalAmount(0);
    setShowForm(false);

    // remove query params
    window.history.replaceState({}, document.title, window.location.pathname);

    // window.location.reload();
  };

  useEffect(() => {
    if (queryStatus && queryMessage) {
      // alert(queryMessage);
      setPaymentStatus(queryStatus === "true" ? true : false);
      setPaymentMessage(queryMessage);

      if (queryStatus === "true") setShowTicketSummary(true);
    }
  }, [queryStatus, queryMessage]);

  useEffect(() => {
    if (quantities) {
      const total = quantities.reduce(
        (acc, curr) => acc + curr.quantity * curr.price,
        0
      );
      setTotalAmount(total);
    }
  }, [quantities]);

  useEffect(() => {
    const fetchEvent = async () => {
      const event = await getEventById(eventId);
      console.log(event);
      if (event.status === false) {
        setEventData(null);
        setFetching(false);
      } else {
        setEventData(event);
        const quantities = event.eventtickets.map((ticket) => {
          console.log("ticket", ticket);
          return { id: ticket.id, quantity: 0, price: Number(ticket.price) };
        });
        console.log("quantities", quantities);
        setQuantities(quantities);
        setFetching(false);
      }
    };
    if (fetching && !eventData) {
      fetchEvent();
    }
  }, [eventData, eventId, fetching, quantities]);

  return (
    <div className="main">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {eventData && eventData.name ? eventData.name : metaTitle}
        </title>
        <meta name="description" content={metaDescription} />
        <meta
          name="image"
          content={
            eventData && eventData.imageURL ? eventData.imageURL : metaImage
          }
        />
      </Helmet>
      {paymentStatus !== false &&
        !gatewayFormData &&
        !fetching &&
        eventData && (
          <div className="custom-container row">
            {/* top/left col */}

            <div className="col-xs-12 col-md-6 no-mp">
              <div className="image-container">
                <img
                  src={eventData.imageURL}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  alt={eventData.name}
                />
              </div>
            </div>

            {/* bottom/right col */}
            <div className="col-xs-12 col-md-6 no-mp">
              {!showForm && (
                <div className="start-container">
                  <button
                    onClick={() => setShowForm(true)}
                    className="custom-button"
                  >
                    buy your tickets
                  </button>
                </div>
              )}

              {showForm && !gatewayFormData && (
                <div className="form-container">
                  <span>
                    <span className="color-primary h1">ENTER</span>
                    <span className="color-secondary h1"> DETAILS</span>
                  </span>
                  <form onSubmit={handleSubmit}>
                    {/* name */}
                    <div
                      style={{
                        marginTop: "10px",
                      }}
                      className="form-group"
                    >
                      <input
                        style={{ textTransform: "uppercase" }}
                        required
                        type="text"
                        placeholder="ENTER NAME"
                        className="form-control"
                        id="name"
                        onChange={handleInputChange}
                      />
                    </div>
                    {/* phone */}
                    <div className="form-group">
                      <input
                        required
                        type="text"
                        placeholder="ENTER PHONE NUMBER"
                        className="form-control"
                        id="phone"
                        onChange={handleInputChange}
                      />
                    </div>
                    {/* email */}
                    <div className="form-group">
                      <input
                        required
                        type="email"
                        placeholder="ENTER EMAIL ADDRESS"
                        className="form-control"
                        id="email"
                        onChange={handleInputChange}
                      />
                    </div>
                    {/* tickets */}
                    <p className="color-secondary h2">Select Category</p>

                    {/* table */}
                    <div className="form-group">
                      <table>
                        <thead>
                          <tr>
                            <th>CATEGORIES</th>
                            <th>PRICE</th>
                            <th>QUANTITY</th>
                            <th>AMOUNT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {eventData.eventtickets.map((ticket, index) => (
                            <tr key={index}>
                              <td>{ticket.title}</td>
                              <td>
                                AED{" "}
                                <span className="color-secondary">
                                  {Number(ticket.price).toFixed(2)}
                                </span>
                              </td>
                              {/* quantity */}
                              <td
                                style={{
                                  display: "flex",
                                  flexDirection: "row",

                                  alignItems: "center",
                                }}
                              >
                                <button
                                  data-ticket-id={ticket.id}
                                  onClick={handleQuantityDecrease}
                                  className="quantity-button-right no-mp"
                                >
                                  -
                                </button>
                                <input
                                  style={{
                                    zIndex: 3,
                                    textAlign: "center",
                                  }}
                                  className="quantity-input"
                                  type="number"
                                  min="0"
                                  data-ticket-id={ticket.id}
                                  value={
                                    quantities.find((x) => x.id === ticket.id)
                                      .quantity || 0
                                  }
                                  onChange={(e) =>
                                    handleQuantityChange(
                                      ticket.id,
                                      Number(e.target.value)
                                    )
                                  }
                                />
                                <button
                                  data-ticket-id={ticket.id}
                                  onClick={handleQuantityIncrease}
                                  className="quantity-button-left no-mp"
                                >
                                  +
                                </button>
                              </td>
                              {/* amount */}
                              <td className="color-primary">
                                AED{" "}
                                {Number(
                                  ticket.price *
                                    quantities.find((x) => x.id === ticket.id)
                                      .quantity || 0
                                ).toFixed(2)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <hr
                      style={{
                        border: "0.5px solid #C9A147",
                      }}
                    />

                    {/* total amount */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                    >
                      <span className="color-secondary h2">
                        {" "}
                        TOTAL AMOUNT:{" "}
                      </span>
                      <span className="color-primary h2">
                        AED {Number(totalAmount).toFixed(2)}
                      </span>
                    </div>

                    {/* check to accept terms and conditions */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        paddingTop: "20px",
                      }}
                      className="form-check"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        className="no-mp"
                      >
                        <input
                          required
                          type="checkbox"
                          className=" h3"
                          id="termsAcceptance"
                          style={{
                            marginRight: "10px",
                            width: "24px",
                            height: "24px",
                          }}
                        />
                        <label
                          className=" text-uppercase color-primary h3"
                          htmlFor="termsAcceptance"
                        >
                          {"   "}I accept{" "}
                          <span className="color-secondary h3">
                            terms & conditions
                          </span>
                        </label>
                      </div>
                    </div>

                    {/* checkout button */}
                    <div className="checkout-container">
                      <button
                        style={{
                          marginTop: "20px",
                        }}
                        type="submit"
                        className="custom-button"
                      >
                        checkout
                      </button>
                    </div>
                  </form>
                  <a
                    className="color-primary"
                    target="_blank"
                    rel="noreferrer"
                    href="https://paynest.ae?gtm_source=events_page"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "30px",
                        letterSpacing: "-0.5px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      POWERED BY: PAYNEST FINTECH
                    </div>
                  </a>
                </div>
              )}
            </div>
          </div> // container
        )}

      {gatewayFormData && (
        <div
          className="redirect-container "
          style={{
            fontSize: "26px",
          }}
        >
          <Spinner animation="border" className="color-secondary" />
          <p className="color-primary">
            Please wait while we redirect you to the payment gateway...
          </p>

          <form
            ref={submitGatewayFormRef}
            name="redirect"
            action={gatewayFormData.postUrl}
            method="POST"
          >
            <input type="hidden" name="c" value={gatewayFormData.xml} />
            <input
              type="hidden"
              name="clientCode"
              value={gatewayFormData.merchantId}
            />

            <input type="submit" id="btnSubmit" value="Please wait" hidden />
          </form>
        </div>
      )}

      {/* ticket summary modal */}
      {eventData && (
        <TicketSummaryModal
          eventDetails={eventData}
          onOpen={showTicketSummary}
          onClose={handleModalClose}
        />
      )}

      {/* payment status */}
      {paymentStatus === false && (
        <div
          className="redirect-container"
          style={{
            fontSize: "26px",
          }}
        >
          <p className="color-primary">Payment Failed!</p>
          <p className="color-secondary">
            {queryOrderId ? `Transaction Id: ${queryOrderId}` : ""}{" "}
          </p>
          <p>{paymentMessage ? `${paymentMessage}` : ""} </p>

          <button
            onClick={() => {
              window.history.replaceState(
                {},
                document.title,
                window.location.pathname
              );
              window.location.reload();
            }}
            className="custom-button"
            style={{
              marginTop: "20px",
              width: "300px",
            }}
          >
            Start Over
          </button>
        </div>
      )}
    </div>
  );
}
